
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wins-and-reviews/[review]",
      function () {
        return require("private-next-pages/wins-and-reviews/[review].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wins-and-reviews/[review]"])
      });
    }
  